module.exports = __webpack_public_path__ + "img/icon-show-group.9a69ca55.svg";